export enum MessageStatus {
  Warning = 0,
  Success = 1,
  Error = 2,
  Pending = 3
}
